import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ArticleEditInfo} from "../model/article-edit-info";
import {Observable} from "rxjs/Observable";
import {ArticleListItem} from "../model/article-list-item";

@Injectable()
export class ArticleService {

  constructor(private httpClient: HttpClient) {
  }

  private baseUrl = '/api/admin/article';

  createArticle(article: ArticleEditInfo): Promise<any> {
    return this.httpClient.post<any>(this.baseUrl, article).toPromise();
  }

  getArticles(): Observable<ArticleListItem[]> {
    return this.httpClient.get<ArticleListItem[]>(this.baseUrl);
  }

  getArticleEdit(id: string): Promise<ArticleEditInfo> {
    return this.httpClient.get<ArticleEditInfo>(`${this.baseUrl}/${id}`).toPromise();
  }

  deleteArticle(id: string): Promise<any> {
    return this.httpClient.delete(`${this.baseUrl}/${id}`).toPromise();
  }

  updateArticle(articleId: string, article: ArticleEditInfo): Promise<any> {
    return this.httpClient.put(`${this.baseUrl}/${articleId}`, article).toPromise();
  }

  moveArticle(articleId: string, newPosition: number): Promise<any> {
    return this.httpClient.put(`${this.baseUrl}/${articleId}/position/${newPosition}`, null).toPromise();
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/article.service.ts